import React from "react";

const Footer = () => {
  const navigationLinks = [
    { label: "About Us", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Projects", href: "#projects" },
    { label: "Team", href: "#team" },
  ];

  const socialLinks = [
    { label: "LinkedIn", href: "#linkedin" },
    { label: "Facebook", href: "#facebook" },
    { label: "Instagram", href: "#instagram" },
    { label: "X", href: "#x" },
  ];

  const legalLinks = [
    { label: "Privacy Statement", href: "#privacy" },
    { label: "Terms of Service", href: "#terms" },
    { label: "Accessibility", href: "#accessibility" },
  ];

  return (
    <footer className="bg-[#F5F6F4] py-12 px-4" data-aos="fade-up">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
          {/* Logo Section */}
          <div className="flex-shrink-0">
            <div className="flex items-center gap-2">
              <img
                src={require("../../Assets/logo.png")}
                alt="Ecopack Logo"
                className="h-10"
              />
            </div>
          </div>

          {/* Navigation Links Grid */}
          <div className="flex-1 max-w-2xl">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {/* Navigation Column */}
              <div className="space-y-3">
                {navigationLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    className="block text-gray-600 hover:text-[#8A9A5B] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                ))}
              </div>

              {/* Social Media Column */}
              <div className="space-y-3">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    className="block text-gray-600 hover:text-[#8A9A5B] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                ))}
              </div>

              {/* Legal Links Column */}
              <div className="space-y-3 col-span-2">
                {legalLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    className="block text-gray-600 hover:text-[#8A9A5B] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex items-center justify-center">
            <p className="text-sm text-gray-500 flex items-center gap-1">
              &copy; 2025 Ecopack. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
